var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.999999C18.0751 0.999999 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 0.999999 12C0.999999 5.92487 5.92487 1 12 0.999999ZM12 -5.24537e-07C18.6274 -8.1423e-07 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 -2.34843e-07 18.6274 -5.24537e-07 12C-8.1423e-07 5.37258 5.37258 -2.34843e-07 12 -5.24537e-07ZM16.8867 12L16.8864 12.0003L16.25 12.6367L10.5228 18.364L9.88636 17.7276L15.6136 12.0003L9.88604 6.27276L10.5224 5.63636L16.25 11.3639L16.2503 11.3636L16.8867 12Z",
    fill: "#9654FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.06fee24c24b3573cde87f344c8089087.svg";
export { ForwardRef as ReactComponent };